import { render, staticRenderFns } from "./teacherMicroLesson.vue?vue&type=template&id=96a4bc56&scoped=true&"
import script from "./teacherMicroLesson.vue?vue&type=script&lang=js&"
export * from "./teacherMicroLesson.vue?vue&type=script&lang=js&"
import style0 from "./teacherMicroLesson.vue?vue&type=style&index=0&id=96a4bc56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a4bc56",
  null
  
)

export default component.exports